// extracted by mini-css-extract-plugin
module.exports = {"title":"_0ba4d55","titleWrapper":"_0608a78","open":"_aff9457","icon":"_74172b4","iconOpen":"_d24e19e"};